export const DATEFORMATSTRING = `MMM d, yyyy`;
export const TIMEFORMATSTRING = `h:mm a`;
export const APPLE_APP_ID = '6498716365';
